"use strict";
import { useAddressFromEns, useENSName } from "features/ens/api";
import { ENS_SUFFIX } from "features/ens/constants";
import { getValidAddress } from "utils/addresses";
import { useDebounce } from "utilities/src/time/timing";
export function useENS({ nameOrAddress, autocompleteDomain = false }) {
  const debouncedNameOrAddress = useDebounce(nameOrAddress) ?? null;
  const validAddress = getValidAddress(debouncedNameOrAddress, false, false);
  const maybeName = validAddress ? null : debouncedNameOrAddress;
  const { data: name, isLoading: nameFetching } = useENSName(validAddress ?? void 0);
  const { data: address, isLoading: addressFetching } = useAddressFromEns(
    autocompleteDomain ? getCompletedENSName(maybeName) : maybeName
  );
  return {
    loading: nameFetching || addressFetching,
    address: validAddress ?? address,
    // if nameOrAddress is a name and there's a valid address resolution, it must be a valid ENS
    name: name ?? (address && nameOrAddress) ?? null
  };
}
export function getCompletedENSName(name) {
  if (!name) {
    return null;
  }
  if (name === "uni") {
    return null;
  }
  return name.endsWith(ENS_SUFFIX) ? name : name.concat(ENS_SUFFIX);
}
